import Compare from "../marketing/Compare";

export default function CompareWhoBrewVsV1ce() {
  return (
    <Compare
      competitor="V1CE"
      path="/compare/whobrew-vs-v1ce"
      seoTitle="WhoBrew vs V1CE — NFC business card comparison"
      seoDescription="WhoBrew compared to V1CE. Software, hardware, lead capture, and where each one fits."
      positioning="V1CE leads with hardware — premium materials, engraved personalization, gift-grade presentation. WhoBrew leads with software — the editor, the contact form, the leads inbox where card-using people spend their time after the tap."
      wedge={{
        headline: "More product, more often used",
        italicWord: "used",
        subhead:
          "V1CE's center of gravity is the physical card; the software is a companion to the hardware, with lead capture and analytics sold as paid add-ons. WhoBrew leads with the software. The editor, the contact form, the leads inbox — the surfaces a card-user touches every week — are the headline product. Lead capture and per-link analytics are included on Pro, not a SKU upsell.",
      }}
      outcomeStats={[
        {
          label: "Where the product lives",
          whobrew: "Software-first",
          competitor: "Hardware-first",
          context: "Editor, forms, inbox — used every week.",
        },
        {
          label: "Lead capture · analytics",
          whobrew: "Included on Pro",
          competitor: "Paid add-ons",
          context: "Custom forms, source attribution.",
        },
        {
          label: "Custom contact-form fields",
          whobrew: "Up to 4 per link",
          competitor: "Standard or add-on",
          context: "Per-persona qualifying questions.",
        },
      ]}
      rows={[
        { feature: "Free tier",          whobrew: "Free forever",       competitor: "No software tier" },
        { feature: "Card materials",     whobrew: "PVC",                competitor: "Metal, wood, premium finishes" },
        { feature: "Lead capture",       whobrew: "Included on Pro",    competitor: "Add-on (paid)" },
        { feature: "Per-link analytics", whobrew: "Included on Pro",    competitor: "Add-on (paid)" },
        { feature: "Custom contact-form fields", whobrew: "Up to 4 per link (Pro)", competitor: "Standard or add-on" },
        { feature: "Per-link source attribution", whobrew: true,        competitor: false },
        { feature: "Software platform",  whobrew: "First-class",        competitor: "Companion to hardware" },
        { feature: "Editor depth",       whobrew: "First-class",        competitor: "Card-design-led" },
      ]}
      whereTheyWin="V1CE has the most premium card materials in the category and the most polished gift-grade presentation. If you're an executive who specifically wants a metal or premium-finish card to hand to other executives — and the card itself is the gift — V1CE is the right answer. The card is the product."
      learnFromThem={{
        intro:
          "Honest comparison goes both ways. A few things V1CE does well that WhoBrew should consider — not as defensive copy, as roadmap input.",
        items: [
          {
            title: "Card material catalog.",
            body: "Metal, wood, recycled options. We ship one PVC SKU. A premium-card tier — even just a brushed-metal option — would compete directly for the executive-gift use case we currently cede entirely.",
          },
          {
            title: "Engraving / laser personalization.",
            body: "Their cards can carry a name, a logo, or a custom etched element. We print to PVC. A premium-tier engraved option pairs well with the proposed material upgrade.",
          },
          {
            title: "Concierge ordering for high-value buyers.",
            body: "Their site funnels enterprise orders through a relationship motion. Worth considering for our Teams tier — a white-glove path for orders over a certain card count.",
          },
          {
            title: "Card-as-gift framing.",
            body: "Their marketing treats the card as something you'd give an executive — packaging, presentation, the moment of handoff. Our PVC card is a tool; theirs is a gift. There's room to add gift-grade packaging without changing the SKU.",
          },
        ],
      }}
      recommendation="Pick V1CE if the physical card material is the point of the purchase — the executive who wants to hand other executives a metal object. Pick WhoBrew if the work after the tap is the point — the editor, the contact form, the leads inbox, all included rather than sold as add-ons."
    />
  );
}
